import React, { useState, useEffect, useCallback } from "react";
import {
    Grid,
    List,
    Button,
    ListItem,
    makeStyles,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import FormHeader from "../../../../Components/FormHeader";
import DatePicker from 'react-date-picker';
import SaveIcon from '@material-ui/icons/Save';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


/** Third party dependencies */
import html2canvas from 'html2canvas';


/** Local dependencies & Libraries */
import Services from '../../../../Services';

import { helpers } from '../../../../helpers';

import { Imports } from '../../../../Imports';

import Snackbar from '../../../../Components/Snackbar';
import { getImageUrl } from "../../../../helpers/getImageUrl";
import { documentSubmit } from "../../../../helpers/api";
// import { DatePicker } from "antd";
var moment = require('moment-timezone');


const {
    users,
    hr,
    Storage,
} = Services;

const {
    showSnackBar,
    getGenerator,
} = helpers;

const {
    styles: {
        displayNoneStyles: useStyles
    }
} = Imports;


const DriverInformation = () => {

    const classes = useStyles();
    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        licenseNumber: "",
        issueState: "",
        expirationDate: new Date(),
        type: false,
        dateToday: new Date()
    })


    useEffect(async () => {
        let userProfile = await JSON?.parse(localStorage?.user_profile);
        let res = await hr?.getAllApplicantsByIDApplicantLogin({ id: userProfile?.id })

        let data = {
            firstName: res?.employee?.firstName || '',
            middleName: res?.employee?.middleName || '',
            lastName: res?.employee?.lastName || '',
        }
        setFormData(prev => ({ ...prev, ...data }))

    }, [])


    const [isPosting, setPosting] = useState(false);
    const access = localStorage.getItem("access_jwt") || null
    const history = useHistory()

    async function submit() {

        let data = {
            issueState: formData?.issueState || null,
            expirationDate: formData?.expirationDate || null,
            licenseNumber: formData?.licenseNumber || null,
            dateToday: formData?.dateToday || null,
            type: formData?.type?.dl || formData?.type?.cdl || null,
            signature: document?.getElementById("signatureApplicant").value

        }
        documentSubmit(setPosting, data, 18, [], access, history)
    }


    return (
        <Grid container xs={12} className="LiqForms-Container">
            <Snackbar></Snackbar>
            {/* <FormHeader/> */}
            <Grid className={isPosting ? classes.DisplayNone : 'FormsHeader'}>
                <List>
                    <ListItem>
                        <Grid className="FormMenuLogo"></Grid>
                    </ListItem>
                    <ListItem>
                        <Button onClick={submit}>
                            <SaveIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.print()}>
                            <LocalPrintshopIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.close()}>
                            <CancelIcon />
                        </Button>
                    </ListItem>
                </List>
            </Grid>
            <table id="tablePrint" className="MainTable capture">
                <tr className="w100">
                    <td className="w100">
                        <table className="SecondMainTable">
                            <tr className="w100">
                                <td className="w100">
                                    <table className="w100">
                                        <tbody className="w100">
                                            <tr className="w100 row justify-between">
                                                <td>
                                                    <div className="PreEmploymentFileBlue">
                                                        BENEFIT DEPARTMENT
                                                    </div>
                                                </td>
                                                <td className=" justify-center" style={{ width: '60%' }}>
                                                    {/* <div className="TGSLogo"></div> */}
                                                    <div className="logoImageTGS"></div>
                                                </td>
                                            </tr>
                                            <tr className="w100">
                                                <td colspan="2" className="w100 header font16 bold textCenter">Driver Information Form</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <table className="w100 mt10">
                            <tbody className="w100">

                            </tbody>
                        </table>

                        <table className="w100" style={{ margin: '' }}>
                            <tbody className="w100">

                                <tr className="width100 row">
                                    <td className="w80 row"><p style={{ width: '80%', paddingTop: '10px' }}> Name</p>
                                        <input type="text" name="officersName" id="officersName" className="w100 bn bb input-capitalization"
                                            value={
                                                `${formData?.firstName} ${formData?.lastName}`
                                            }
                                        // disabled
                                        />
                                    </td>

                                </tr>
                                <tr className="width100 row">
                                    <td className="w80 row"><p style={{ width: '80%', paddingTop: '10px' }}>Driver's License Number:</p>
                                        <input type="text" name="textfield" id="position" className="w100 bn bb input-capitalization"
                                            onChange={(e) => setFormData(prev => ({ ...formData, licenseNumber: e.target.value }))}
                                            value={formData?.licenseNumber}
                                        />

                                    </td>

                                </tr>
                                <tr className="width100 row">
                                    <td className="w80 row"><p style={{ width: '80%', paddingTop: '10px' }}>Issuing State</p>
                                        <input type="text" name="textfield" id="position" className="w100 bn bb input-capitalization"
                                            onChange={(e) => setFormData(prev => ({ ...formData, issueState: e.target.value }))}
                                            value={formData?.issueState}
                                        />

                                    </td>
                                </tr>
                                <tr className="width100 row">
                                    <td className=" row" style={{ width: "58%", paddingTop: '' }}><p style={{ width: '100%', marginTop: '10px' }}>Expiration Date:</p>
                                        {/* <DatePicker
                                            onChange={(e) => setFormData(prev => ({ ...formData, expirationDate: e }))}
                                            value={formData?.expirationDate}
                                            id="offerDate"
                                            className="datePickerReact  "
                                        /> */}
                                        {/* <DatePicker
                                            onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { ...prev?.personPartTwo, datePerson: e } }))}

                                            value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className="datePickerReact mm w-80"

                                        /> */}
                                        <input className="inp" />
                                    </td>
                                </tr>
                                <tr className="width100 row">
                                    <td className="w50 row"><p style={{ width: '71%', paddingTop: '7px' }}>Type</p>

                                        <td style={{ margin: 'auto' }} >
                                            <input
                                                onChange={(e) => setFormData(prev => ({ ...formData, type: { ...formData?.type, dl: true } }))}
                                                type="checkbox"
                                                id="checkbox1"
                                                name="checkbox1"
                                                style={{ marginRight: '10px' }} />DL</td>
                                        <td style={{ margin: 'auto' }}>
                                            <input
                                                onChange={(e) => setFormData(prev => ({ ...formData, type: { ...formData?.type, cdl: true } }))}
                                                type="checkbox"
                                                id="checkbox2"
                                                name="checkbox2"
                                                style={{ marginLeft: '15px', marginRight: '10px' }} />CDL</td>

                                    </td>
                                </tr>




                            </tbody>
                        </table>
                        <table className="" style={{ width: '80%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "center" }}>
                                        <h1 style={{ fontSize: '16px' }}>Acknowledgement</h1>
                                    </td>
                                </tr>
                                <tr>


                                    <td className="mt10 pt10 mb10 pb10 " >I understand that I am not allowed to operate a Trans-Global Solutions, Inc. company owned vehicle or
                                        operate a personal vehicle while working for Trans-Global Solutions, Inc. if my state driving privileges are
                                        temporarily or permanently revoked, if my driver’s license expires or if my driving record reflects more
                                        than two (2) severe driving infractions or one (1) substance related infraction in the last three (3) years. I
                                        understand that if my driving privileges become revoked or I receive more than two (2) severe driving
                                        infractions or one (1) substance related driving infraction I must inform Trans-Global Solutions, Inc. within
                                        twenty-four (24) hours of such event and must refrain from operating a Trans-Global Solutions, Inc. owned
                                        vehicle or operating a personal vehicle while performing my job with Trans-Global Solutions, Inc. I
                                        understand that operating a Trans-Global Solutions, Inc. owned vehicle or a personal vehicle while in the
                                        commission of my labors with Trans-Global Solutions, Inc. is cause for disciplinary action, including
                                        termination</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w100 mt20">
                            <tbody className="w100">
                                <tr className="row" style={{ width: '42%', marginLeft: '38px' }}>
                                    <td className="w100 row"><p style={{ width: '100%' }}>Employee Name</p>
                                        <input type="text" name="officersName" id="officersName" className=" bn bb input-capitalization"
                                            value={
                                                `${formData?.firstName} ${formData?.lastName}`
                                            }
                                            disabled
                                        />
                                    </td>

                                </tr>

                                <tr className="w90 row " style={{ margin: 'auto' }}>
                                    {/* <p style={{ margin: 'auto' }}>  Signature </p> */}
                                    <td className="w50 mt10" style={{ display: 'flex', flexDirection: 'row', border: '3px solid lightblue ', padding: '5px' }}> <p className="mt10">Signature:</p>
                                        <input type="text" id="signatureApplicant" name="textfield"

                                            className="w96 bn bb   signatureClass font-20"
                                        />
                                    </td>
                                    <p style={{ margin: 'auto' }}>Date</p>
                                    <td className="w40">
                                        {/* <input type="text" id="offeree" name="textfield" className="w100 bn bb pt10 pb10 signatureClassOther font-20" /> */}
                                        <DatePicker
                                            onChange={(value) => setFormData(prev => ({ ...prev, dateToday: value }))}
                                            value={formData?.dateToday}
                                            id="offerDate"
                                            disabled
                                            className="datePickerReact mm"
                                        />

                                    </td>
                                </tr>
                                {/* <tr className="w100 row">
                                    <td className="w50 bold">Signature</td>
                                    <td className="w20 bold">Date</td>
                                </tr> */}
                            </tbody>
                        </table>
                        <table className="w100 textCenter mt30">
                            <tbody className="w100">
                                <tr className="w100">
                                    <td className="w100" >Trans-Global Solutions, Inc.,</td>
                                    <td className="w100">1735 W. Cardinal Dr., Beaumont, Texas 77705</td>
                                    <td className="w100">Phone (409) 720-5413 – Fax (409) 729-7041</td>


                                </tr>
                            </tbody>
                        </table>
                        <table className="w100 mt20">
                            <tbody>
                                <tr> </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </table>
        </Grid>
    );

}
export default DriverInformation;